import React, { useEffect, useState } from 'react';
import QuejaSeguimiento from './_QuejaSeguimiento.js';
import QuejaHeader from './QuejaHeader.js';
import QuejaInfo from './QuejaInfo.js';
import { useParams } from 'react-router-dom';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import MyModal from 'helpers/MyModal.js';
import AddSeguimiento from './_AddSeguimiento.js';
import NotificationAlert from 'componentes/generic/Notification.js';
import CloseQueja from './_CloseQueja.js';
import QuejaDetalle from './QuejaDetalle.js';
import EditExpedientePil from './_EditExpedientePil.js';
import EditOportunidad from './_EditOportunidad.js';
import AddComment from './_AddComment.js';
import ReOpenQueja from './_ReOpenQueja.js';
import EditFolioExt from './_EditFolioExt.js';
import EditExpedienteData from './_EditExpedienteData.js';
import EditConsumidorData from './_EditConsumidorData.js';
import ConfirmAction from 'helpers/ConfirmationModal.js';
import EditProductoData from './_EditProductoData.js';
import EditPreconciliacion from './_EditPreconciliacion.js';

const URI = ApiEndpoint + 'operations/';
const URIAdmin = ApiEndpoint + 'administration/';
const QuejaDetail = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [quejaInfo, setQuejaInfo] = useState(false);
  const [quejaSeguimiento, setQuejaSeguimiento] = useState([]);
  const [determinante, setDeterminante] = useState(false);
  const [modalShowConfirmDelete, setModalShowConfirmDelete] = useState(false);
  const [subcustomer, setSubcustomer] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const [isError, setIsError] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const isAdmin = Auth.isAdmin();

  const [modal, setModal] = useState({ type: null, props: {} });

  let { id } = useParams();
  const MODAL_TYPES = {
    SEGUIMIENTO: 'SEGUIMIENTO',
    EXPEDIENTE: 'EXPEDIENTE',
    EDITEXPEDIENTE: 'EDITEXPEDIENTE',
    FOLIOEXT: 'FOLIOEXT',
    CIERRE: 'CIERRE',
    OPORTUNIDAD: 'OPORTUNIDAD',
    COMMENT: 'COMENTARIO',
    REOPEN: 'REOPEN',
    SEGUIMIENTOEDIT: 'SEGUIMIENTOEDIT',
    CONSUMIDOR: 'CONSUMIDOR',
    PRODUCTO: 'PRODUCTO',
    PRECONCILIACION: 'PRECONCILIACION'
  };

  const openModal = (type, props = {}) => {
    setModal({ type, props });
  };

  const closeModal = () => {
    setModal({ type: null, props: {} });
    getQueja();
  };

  const confirmDeleteQueja = () => {
    setModalShowConfirmDelete(true);
  };

  const handleConfirmDelete = isConfirmed => {
    if (!isConfirmed) {
      return;
    }
    deleteCurrentQueja();
  };

  const deleteCurrentQueja = async () => {
    httpClient(
      'POST',
      URI + 'delete/',
      { recepcionqueja: id },

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          let path = `/`;
          window.location.href = path;
        } else {
          setErrorMesagge(response.data.message);
          setIsError(true);
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getQuejaSeguimiento = async () => {
    setQuejaSeguimiento(null);

    httpClient(
      'GET',
      URI + 'quejaseguimiento/' + id,
      {},

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setQuejaSeguimiento(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getQueja = async () => {
    setQuejaInfo(null);
    httpClient(
      'GET',
      URI + 'queja/' + id,
      {},

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setQuejaInfo(response.data);
          setIsOpen(response.data.idstatus == 12);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getDeterminante = async idDeterminante => {
    setDeterminante(null);

    httpClient(
      'GET',
      URIAdmin + 'determinante/' + idDeterminante,
      {},

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDeterminante(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const saveFolioExt = async folioExt => {
    console.log(folioExt);
    httpClient(
      'POST',
      URI + 'savefolio/' + id,
      { folioext: folioExt },

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          getQueja();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const savePreconciliacion = async preconciliacion => {
    console.log(preconciliacion);
    httpClient(
      'POST',
      URI + 'savepreconciliacion/' + id,
      { preconciliacion: preconciliacion },

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          getQueja();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const saveExpedientePil = async expedientePil => {
    console.log(expedientePil);
    httpClient(
      'POST',
      URI + 'savepil/' + id,
      { expediente: expedientePil },

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          getQueja();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const saveOportunidad = async ({ oportunidad, fechaOportunidad }) => {
    httpClient(
      'POST',
      URI + 'saveoportunidad/' + id,
      { oportunidad: oportunidad, fecha: fechaOportunidad },

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          getQueja();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getSubCustomer = async idSubcustomer => {
    setSubcustomer(null);

    httpClient(
      'GET',
      URIAdmin + 'subcustomer/' + idSubcustomer,
      {},

      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setSubcustomer(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (!quejaInfo) {
      getQueja();
      getQuejaSeguimiento();
    }
  }, []);
  useEffect(() => {
    if (quejaInfo) {
      getDeterminante(quejaInfo.iddeterminante);
    }
  }, [quejaInfo]);

  useEffect(() => {
    if (determinante) {
      getSubCustomer(determinante.idsubcliente);
    }
  }, [determinante]);
  return (
    <>
      {quejaInfo && determinante && subcustomer && (
        <>
          <QuejaHeader
            queja={quejaInfo}
            isOpen={isOpen}
            isAdmin={isAdmin}
            confirmDeleteQueja={confirmDeleteQueja}
            setOpenModalReOpen={() =>
              openModal(MODAL_TYPES.REOPEN, {
                idQueja: id,
                currentStatus: quejaInfo?.idstatus,
                setErrorMesagge,
                setShowErrorMessage,
                setIsError
              })
            }
            setOpenModalCierre={() =>
              openModal(MODAL_TYPES.CIERRE, {
                idQueja: id,
                currentStatus: quejaInfo?.idstatus,
                setErrorMesagge,
                setShowErrorMessage,
                setIsError
              })
            }
            setOpenModalConsumidor={() =>
              openModal(MODAL_TYPES.CONSUMIDOR, {
                idQueja: id,
                queja: quejaInfo,
                setErrorMesagge,
                setShowErrorMessage,
                setIsError,
                closeModal
              })
            }
            setErrorMesagge={setErrorMesagge}
            setShowErrorMessage={setShowErrorMessage}
            setIsError={setIsError}
          />
          <QuejaInfo
            isOpen={isOpen}
            queja={quejaInfo}
            determinante={determinante}
            subCustomer={subcustomer}
            setErrorMesagge={setErrorMesagge}
            setShowErrorMessage={setShowErrorMessage}
            setOpenModalFolioExt={() => openModal(MODAL_TYPES.FOLIOEXT)}
            setIsError={setIsError}
            setOpenModalExpediente={() => openModal(MODAL_TYPES.EDITEXPEDIENTE)}
            setOpenModalProducto={() => openModal(MODAL_TYPES.PRODUCTO)}
          />
          <QuejaDetalle
            isOpen={isOpen}
            setOpenModalExpediente={() => openModal(MODAL_TYPES.EXPEDIENTE)}
            setOpenModalFolioExt={() => openModal(MODAL_TYPES.FOLIOEXT)}
            setOpenModalFechaOportunidad={() =>
              openModal(MODAL_TYPES.OPORTUNIDAD)
            }
            setOpenModalPreconciliacion={() =>
              openModal(MODAL_TYPES.PRECONCILIACION)
            }
            detalle={quejaInfo.quejadetalle}
          />
          <QuejaSeguimiento
            isOpen={isOpen}
            quejaSeguimiento={quejaSeguimiento}
            setOpenModal={() =>
              openModal(MODAL_TYPES.SEGUIMIENTO, {
                idQueja: id,
                setErrorMesagge,
                setShowErrorMessage,
                setIsError
              })
            }
            setOpenModalEdit={({ idSeguimiento, currentDate }) =>
              openModal(MODAL_TYPES.SEGUIMIENTOEDIT, {
                idQueja: id,
                idSeguimiento: idSeguimiento,
                currentDate: currentDate,
                setErrorMesagge,
                setShowErrorMessage,
                setIsError
              })
            }
          />
        </>
      )}
      {modal.type === MODAL_TYPES.PRODUCTO && (
        <MyModal
          title="Editar datos de Producto"
          openModal={true}
          closeModal={closeModal}
        >
          <EditProductoData
            idQueja={id}
            queja={quejaInfo}
            closeModal={closeModal}
            setErrorMesagge={setErrorMesagge}
            setIsError={setIsError}
            setShowErrorMessage={setShowErrorMessage}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.COMMENT && (
        <MyModal
          title="Editar comentario"
          openModal={true}
          closeModal={closeModal}
        >
          <AddComment
            idQueja={id}
            currentExpedientePil={quejaInfo?.quejadetalle?.expedientepil}
            saveExpedientePil={data => {
              saveExpedientePil(data);
            }}
            closeModal={closeModal}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.SEGUIMIENTO && (
        <MyModal
          title="Agendar Audiencia"
          openModal={true}
          closeModal={closeModal}
        >
          <AddSeguimiento
            idQueja={id}
            expedientePil={quejaInfo?.quejadetalle?.expedientepil}
            setExpedientePil={data => {
              saveExpedientePil(data);
            }}
            closeModal={closeModal}
            setErrorMesagge={setErrorMesagge}
            setIsError={setIsError}
            setShowErrorMessage={setShowErrorMessage}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.SEGUIMIENTOEDIT && (
        <MyModal
          title="ReAgendar Audiencia"
          openModal={true}
          closeModal={closeModal}
        >
          <AddSeguimiento
            idQueja={id}
            idSeguimiento={modal.props.idSeguimiento}
            currentDate={modal.props.currentDate}
            closeModal={closeModal}
            setErrorMesagge={setErrorMesagge}
            setIsError={setIsError}
            setShowErrorMessage={setShowErrorMessage}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.CONSUMIDOR && (
        <MyModal
          title="Modificar datos de Consumidor"
          openModal={true}
          closeModal={closeModal}
        >
          <EditConsumidorData {...modal.props}></EditConsumidorData>
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.OPORTUNIDAD && (
        <MyModal
          title="Agregar Oportunidad"
          openModal={true}
          closeModal={closeModal}
        >
          <EditOportunidad
            saveOportunidad={saveOportunidad}
            currentOportunidad={quejaInfo?.quejadetalle?.oportunidad}
            currentFechaOportunidad={quejaInfo?.quejadetalle?.fechaoportunidad}
            closeModal={closeModal}
            setErrorMesagge={setErrorMesagge}
            setIsError={setIsError}
            setShowErrorMessage={setShowErrorMessage}
          />
        </MyModal>
      )}

      {modal.type === MODAL_TYPES.EXPEDIENTE && (
        <MyModal
          title="Editar Expediente PIL"
          openModal={true}
          closeModal={closeModal}
        >
          <EditExpedientePil
            idQueja={id}
            currentExpedientePil={quejaInfo?.quejadetalle?.expedientepil}
            saveExpedientePil={data => {
              saveExpedientePil(data);
            }}
            closeModal={closeModal}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.EDITEXPEDIENTE && (
        <MyModal
          title="Editar Datos de Expediente"
          openModal={true}
          closeModal={closeModal}
        >
          <EditExpedienteData
            idQueja={id}
            closeModal={closeModal}
            setErrorMesagge={setErrorMesagge}
            setShowErrorMessage={setShowErrorMessage}
            setIsError={setIsError}
          ></EditExpedienteData>
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.FOLIOEXT && (
        <MyModal
          title="Editar Folio Externo"
          openModal={true}
          closeModal={closeModal}
        >
          <EditFolioExt
            idQueja={id}
            currentFolioExt={quejaInfo?.quejadetalle?.folioext}
            saveFolioExt={data => {
              saveFolioExt(data);
            }}
            closeModal={closeModal}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.PRECONCILIACION && (
        <MyModal
          title="Editar Preconciliacion"
          openModal={true}
          closeModal={closeModal}
        >
          <EditPreconciliacion
            idQueja={id}
            currentPreconciliacion={quejaInfo?.quejadetalle?.preconciliacion}
            savePreconciliacion={data => {
              savePreconciliacion(data);
            }}
            closeModal={closeModal}
          />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.CIERRE && (
        <MyModal
          title="Cierre de Queja"
          openModal={true}
          closeModal={closeModal}
        >
          <CloseQueja {...modal.props} closeModal={closeModal} />
        </MyModal>
      )}
      {modal.type === MODAL_TYPES.REOPEN && (
        <MyModal
          title="Cierre de Queja"
          openModal={true}
          closeModal={closeModal}
        >
          <ReOpenQueja
            idQueja={id}
            setErrorMesagge={setErrorMesagge}
            setShowErrorMessage={setShowErrorMessage}
            setIsError={setIsError}
            closeModal={closeModal}
          />
        </MyModal>
      )}
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
        isError={isError}
      />
      <ConfirmAction
        open={modalShowConfirmDelete}
        handleClose={() => {
          setModalShowConfirmDelete(false);
        }}
        title="Aviso"
        message="Desea eliminar el expediente seleccionado?"
        ConfirmAction={handleConfirmDelete}
        ConfirmTitle="Aceptar"
      ></ConfirmAction>
    </>
  );
};

export default QuejaDetail;
